import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { ArrowLeft } from '@phosphor-icons/react';
import api from '../lib/api';

export default function OrgForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      await api.post('/organiser/password/forgot', { email: email.trim() });
    } catch {}
    setSent(true);
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-[#F4F6F5] flex flex-col items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md mb-4">
        <Link to="/home" className="inline-flex items-center gap-1.5 text-sm text-[#455561] font-semibold hover:text-[#1B4332] transition-colors" data-testid="back-to-home">
          <ArrowLeft className="w-4 h-4" weight="bold" /> Back to home
        </Link>
      </div>
      <Card className="w-full max-w-md p-8 bg-white border-[#E1E6E4] rounded-xl space-y-6">
        {sent ? (
          <div className="text-center space-y-4" data-testid="forgot-sent">
            <div className="w-14 h-14 bg-[#E8F5E9] rounded-full flex items-center justify-center mx-auto">
              <svg className="w-7 h-7 text-[#2E7D32]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
            </div>
            <h2 className="text-xl font-bold text-[#1D242B]">Check your inbox</h2>
            <p className="text-sm text-[#455561]">If there's an account for that email, we've sent a link to reset your password. Check your junk folder too.</p>
            <Link to="/login" className="text-sm text-[#1B4332] font-semibold hover:underline">Back to login</Link>
          </div>
        ) : (
          <>
            <div className="text-center">
              <h1 className="text-2xl font-bold text-[#1D242B]">Forgot password</h1>
              <p className="text-sm text-[#455561] mt-1">Enter your email and we'll send you a reset link</p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-sm font-semibold text-[#455561] mb-1 block">Email</label>
                <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={submitting} className="w-full h-12 bg-[#1B4332] hover:bg-[#163B2B] text-white rounded-xl font-semibold" data-testid="forgot-submit">
                {submitting ? 'Sending...' : 'Send reset link'}
              </Button>
            </form>
            <p className="text-center text-sm text-[#455561]">Remember your password? <Link to="/login" className="text-[#1B4332] font-semibold hover:underline">Log in</Link></p>
          </>
        )}
      </Card>
    </div>
  );
}
